import { Button, Table,Spin, Tag} from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import {Col, Row } from 'react-bootstrap';
import {AUTH_URL} from '../constants';
import { TfiReload } from 'react-icons/tfi';
import {ILoanFine} from '../factory/interfaces'
import { IoMdArrowDropright } from 'react-icons/io';
import { notify, toastStyle } from '../pages/LoginPage';



const TopupsTable = () => {
    const [topups, setTopups] = useState<ILoanFine[]>()

    //Functions

 const columns = [
    {
    title: 'No.',
    dataIndex: 'count',
    render: (text:any, record:any, index:any) => index + 1,
  },
  {
    title: 'Client',
    dataIndex: 'client',
    key: 'client',
  },
  {
    title: 'Branch',
    dataIndex: 'branch',
    key: 'branch',
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
  },
    {
    title: 'Date of record',
    dataIndex: 'date_of_creation',
    key: 'date_of_creation',
  },

]

    const getLoanTopups = async()=>{
      try {
        const response = await axios.post(`${AUTH_URL}/finances/loans/topups`, {withCredentials: true})
        if(response.data.success){
          setTopups(response.data.topups)
        }else{
        notify(response.data.message, toastStyle)
          setTopups([])
        }
        
      } catch (error: any) {
        notify(error.message, toastStyle)
      }
    }

  useEffect(()=>{
    getLoanTopups()
  }, [])

  return (
    <>
    {topups? 
    <>

    <Row className=' justify-content-between align-items-center py-0 g-0'>
        <Col className='text-start py-2'>
         <h4 className='medium text-uppercase fw-bold' style={{color: '#052c65', fontSize: 16}}> <IoMdArrowDropright />Loan Topups</h4>
         </Col>
         <Col className='text-end py-2'>
            <Button  className='rounded-0' type="dashed"> <TfiReload/> <span className='mx-1'>Reload</span></Button>
         </Col>
            
        </Row>
    
     {
      topups &&
      <Table className='rounded-0 transactions-table' id='dlms-expenses-data' bordered dataSource={topups} columns={columns} 
       />
     }
     
      </> : 
        <Spin style={{paddingTop: 100}} tip="Loading topups..." size="large">
        <div className="content" />
      </Spin>

    }
   
    </>
  )
}

export default TopupsTable